import { render, staticRenderFns } from "./PeachList.vue?vue&type=template&id=7312d098&scoped=true"
import script from "./PeachList.vue?vue&type=script&lang=js"
export * from "./PeachList.vue?vue&type=script&lang=js"
import style0 from "./PeachList.vue?vue&type=style&index=0&id=7312d098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7312d098",
  null
  
)

export default component.exports